<script>
    import { onMount } from "svelte";
    import { fade } from "svelte/transition";
    import { push } from "svelte-spa-router";

    let visible = null;

    const sleep = (ms) => new Promise((f) => setTimeout(f, ms));

    const showModels = () => {
        push("/models");
    };

    onMount(async () => {
        await sleep(500); // this fixes an issue where entrace animations don't work on reload. I haven't done it for other routes since it introduces lag - but it's important to do it for this route because it's solely aesthetic.
        visible = true;
        await sleep(1500);
        showModels();
    });
</script>

{#if visible}
    <body in:fade={{ delay: 500, duration: 1200 }} out:fade>
        <div id="black">
            <div
                on:click={showModels}
                style="text-align:center; cursor: pointer;"
            >
                <div id="img_bg">
                    <img
                        src="LogoNoText (black BG).png"
                        width="300"
                        alt="fc_logo"
                    />
                </div>
                <!-- <br />
                <button id="button" in:fade={{ delay: 5000 }} out:fade
                    >Explore models</button
                > -->
            </div>
        </div>
    </body>
{/if}

<svelte:head>
    <meta name="viewport" content="width=1024" />
</svelte:head>

<style>
    @import url("https://fonts.cdnfonts.com/css/mayeka-demo");
    body {
        font-family: "Mayeka Regular Demo", Arial, sans-serif;
    }
    body * {
        user-select: none;
        -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    }
    #black {
        display: block;
        /* set height to to 101 to force scroll bar and avoid logo shifting during fade when Models.svelte scrollbar appears */
        height: 101vh;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: black;
    }
    /* #img_bg {
        overflow: hidden;
        background-color: cyan;
    } */
    /* #button {
        border: 1.5px solid #eeeeee;
        padding: 8px 32px;
        text-align: center;
        text-decoration: none;
        display: inline-block;
        font-size: 16px;
        margin: 4px 2px;
        cursor: pointer;
        background-color: #555555;
        color: white;
        border-radius: 8px;
        transition-duration: 0.4s;
    } */
    /* #button:hover {
        background-color: #999999;
    } */
    #black img {
        transform: scale(0.96);
        opacity: 1;
        transition: opacity 0.4s, transform 0.4s;
    }
    #black img:hover {
        transform: scale(1);
        opacity: 0.25;
    }
</style>
